import { render } from "./accessories-modal.vue?vue&type=template&id=45fbbc5e&scoped=true"
import script from "./accessories-modal.vue?vue&type=script&lang=js"
export * from "./accessories-modal.vue?vue&type=script&lang=js"

import "./accessories-modal.vue?vue&type=style&index=0&id=45fbbc5e&scoped=true&lang=css"
import "./accessories-modal.vue?vue&type=style&index=1&id=45fbbc5e&scoped=true&lang=css"

import exportComponent from "/home/gerind/Desktop/work/gobe-system/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45fbbc5e"]])

export default __exports__